.fa{width:1rem;}